import { useAccountReport } from "./AccountReportContext";
import { useAccounts } from "./AccountsContext";
import { useAuth } from "./AuthContext";
import { useBalance } from "./BalanceContext";
import { useConfig } from "./ConfigContext";
import { useStudent } from "./FeesStudentContext";
import { useSchoolTransactions } from "./FeesTransactionContext";
import { useFinder } from "./FinderContext";
import { useIncomingInvoice } from "./IncomingInvoiceContext";
import { useJournal } from "./JournalContext";
import { useLedger } from "./LedgerContext";
import { useReport } from "./ReportContext";
import { useSchool } from "./SchoolContext";
import { useFeesProfile } from "./FeesProfileContext";
import { useTag } from "./TagContext";
import { useTheme } from "./ThemeContext";
import { useVendor } from "./VendorContext";
import { useFeesDefaulter } from "./FeesDefaulterContext";
import { useFeesDiscount } from "./FeesDiscountContext";
import { useVendorStatement } from "./VendorStatementContext";
import { useOnlineSchoolFees } from "./OnlineSchoolFeesContext";

// Custom hook to clear the state of BusinessContext
export const useClearState = () => {
  const { dispatch: authDispatch} = useAuth();
  const { dispatch: balanceDispatch} = useBalance();
  const { dispatch: configDispatch} = useConfig();
  const { dispatch: reportDispatch} = useReport();
  const { dispatch: tagDispatch} = useTag();
  const { dispatch: vendorDispatch} = useVendor();
  const { dispatch: IncomingInvoiceDispatch} = useIncomingInvoice();
  const { dispatch: ledgerDispatch} = useLedger();
  const { dispatch: accountsDispatch} = useAccounts();
  const { dispatch: themeDispatch} = useTheme();
  const { dispatch: journalDispatch} = useJournal();
  const { dispatch: finderDispatch} = useFinder();
  const { dispatch: accountReportDispatch} = useAccountReport();
  const { dispatch: schoolDispatch} = useSchool();
  const { dispatch: studentDispatch} = useStudent();
  const { dispatch: schoolTransDispatch} = useSchoolTransactions();
  const { dispatch: feesProfileDispatch} = useFeesProfile();
  const { dispatch: feesDefaulterDispatch} = useFeesDefaulter();
  const { dispatch: feesDiscountDispatch} = useFeesDiscount();
  const { dispatch: vendorStatementDispatch} = useVendorStatement();
  const { dispatch: onlineSchoolFeesDispatch} = useOnlineSchoolFees();




  // Function to clear the state
  const clearAllState = () => {
    authDispatch({ type: 'CLEAR'});
    balanceDispatch({ type: 'CLEAR'});
    configDispatch({ type: 'CLEAR'});
    reportDispatch({ type: 'CLEAR'});
    tagDispatch({ type: 'CLEAR'});
    vendorDispatch({ type: 'CLEAR'});
    IncomingInvoiceDispatch({ type: 'CLEAR'});
    ledgerDispatch({ type: 'CLEAR'});
    accountsDispatch({ type: 'CLEAR'});
    themeDispatch({ type: 'CLEAR'});
    journalDispatch({ type: 'CLEAR'});
    finderDispatch({ type: 'CLEAR'});
    accountReportDispatch({ type: 'CLEAR'});
    schoolDispatch({ type: 'CLEAR'});
    studentDispatch({ type: 'CLEAR'});
    schoolTransDispatch({ type: 'CLEAR'})
    feesProfileDispatch({ type: 'CLEAR'})
    feesDefaulterDispatch({ type: 'CLEAR'})
    feesDiscountDispatch({ type: 'CLEAR'});
    vendorStatementDispatch({ type: 'CLEAR'});
    onlineSchoolFeesDispatch({ type: 'CLEAR'});
  }

  return clearAllState;
};
